import { useEffect, useRef, useState } from "react";
import "../App.css";
import "ol/ol.css";
import { Map as OLMap } from "ol";
import { map } from "./MainLayer";
import data from "../data/QuickAccessSlider";
import LeftSideMenu from "../initial/menu/LeftSideMenu";
import QuickMenu from "../initial/quickSlider/QuickMenu";
import Overlay from "ol/Overlay.js";
import LocationSideBar from "../locationSideBar/LocationSideBar";
import ForecastModel from "./forecastModel/ForecastModel";
import MessureUnits from "./messureUnits/MessureUnits";
import ExtremeHeavyRainfall from "../ExtremeHeavyRainfall/ExtremeHeavyRainfall/ExtremeHeavyRainfall";
import TimeRangeNotification from "../TimeLine/TimelineNotifications/TimeRangeNotification";
import MainLayerPopup from "../initial/layersPopup/MainLayerPopup";
import AddLayerComp from "../initial/layersPopup/AddLayerComp";
import { VoiceRecognitionConsole } from "../initial/quickSlider/VoiceRecognitionConsole";
import { unByKey } from "ol/Observable";
import "ol/ol.css";
import arrow from "../assets/wind2.png";
import ImageLayer from "ol/layer/Image";
import ImageWMS from "ol/source/ImageWMS";
import FloodModel from "./forecastModel/FloodModel";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { Feature } from "ol";
import { Pixel } from "ol/pixel";
import TimelineService from "../TimeLine/BackgroundMapTimeLine/TimeLineService";
import { useTheme } from "../theme/ThemeContext";
import SummaryComp from "./summeryComp/SummeryComp";
import SummeryFull from "./summeryComp/SummeryFull";
import { earlyWarning } from "./earlyWarning/ShowEarlyWarning";
import { hzIncidents } from "./hazardIncidentsLayers/IncidentsMenuDropDown";
import SimulationPopup from "./simulationPopup/SimulationPopup";
import NotificationPopup, {
  NotificationType,
} from "./simulationPopup/NotificationPopup";
import TerminalPopup from "./simulationPopup/TerminalPopup";
import DetailsEWSeverity from "./summeryComp/detailsSum/detailsEWSeverity";
import DetailsByType from "./summeryComp/detailsSum/DetailsBytype";
import RightSideMenu, { PopupsListType } from "../initial/menu/RightSideMenu";
import { useEWSContext } from "../provider/EWSProvider";
import { useHzContext } from "../provider/HzProvider";
import { useLayout } from "../layout/LayoutContext";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import CloseIcon from "@mui/icons-material/Close";
import { useAllWeatherContext } from "../provider/AllWeatherProvider";
import proj4 from "proj4";
import MinMenu from "./miniMenu/MinMenu";
import { useAirQualityContext } from "../provider/AirQualityProvider";
import ecmwf2 from "../assets/ecmwf.png";
import eumetsat from "../assets/eumetsat.png";
import iconImage from "../assets/ICON.png";
import TornadoSimulationComp from "./extremeWeather/tornadoSimulationComp/TornadoSimulationComp";
import VoiceTerminal from "../chatConsole/chatConsole/VoiceTerminal";
import { Coordinate } from "ol/coordinate";


export function useMap() {
  const mapRef = useRef<OLMap>();
  if (!mapRef.current) {
    mapRef.current = map;
  }
  return mapRef.current;
}

interface TimelineElement {
  id: string;
  stimestamp: number;
  Interval: number;
  edtimestamp: number;
}

let name1: string = "";
let markerPopup: string = "";
let markerPopupWindRemove: string = "";
let markerPopupTempRemove: string = "";
let markerPopupRainRemove: string = "";
let markerPopupAirRemove: string = "";
let markerPopupTidesRemove: string = "";
let markerPopupRainProbabilityRemove: string = "";
let markerPopupLocationWeather: string = "";
let openLayerTypeMap: Map<string, boolean> = new Map();
let timeLineShow: boolean = false;
let globalLayers: ImageLayer<ImageWMS> | null = null;
let clkMarker: string = "";
let clickModel: string = "ECMWF";
let selectMapLayer: string = "windnot";

export function getGlobalLayer(setWeatherLayer: ImageLayer<ImageWMS>) {
  globalLayers = setWeatherLayer;
}

let globalLayersIr: ImageLayer<ImageWMS> | null = null;
export function getGlobalLayerWindir(setWeatherLayer: ImageLayer<ImageWMS>) {
  globalLayersIr = setWeatherLayer;
}

export function setLayersvalue(layerName: string) {
  name1 = layerName;
}

export function LocationMarkerPopup(popupType: string) {
  // console.log("----------popupType-------" + popupType);
  markerPopup = popupType;
  if (popupType === "earlywarning") {
    openLayerTypeMap.set(popupType, true);
  } else if (popupType === "earlywarning not") {
    openLayerTypeMap.set("earlywarning", false);
  } else if (popupType === "hzIncidents") {
    openLayerTypeMap.set(popupType, true);
  } else if (popupType === "hzIncidents not") {
    setTimeout(() => {
      openLayerTypeMap.set("hzIncidents", false);
    }, 100);
    openLayerTypeMap.set("hzIncidents", false);
  } else if (popupType === "windnot") {
    openLayerTypeMap.set("wind", true);
    openLayerTypeMap.set("temperature", false);
    openLayerTypeMap.set("rain", false);
    openLayerTypeMap.set("airPressure", false);
    openLayerTypeMap.set("tides", false);
    openLayerTypeMap.set("rainProbability", false);
  } else if (popupType === "wind") {
    openLayerTypeMap.set("wind", false);
  } else if (popupType === "temperaturenot") {
    openLayerTypeMap.set("temperature", true);
    openLayerTypeMap.set("rain", false);
    openLayerTypeMap.set("wind", false);
    openLayerTypeMap.set("airPressure", false);
    openLayerTypeMap.set("tides", false);
    openLayerTypeMap.set("rainProbability", false);
  } else if (popupType === "temperature") {
    openLayerTypeMap.set("temperature", false);
  } else if (popupType === "rainnot") {
    openLayerTypeMap.set("rain", true);
    openLayerTypeMap.set("wind", false);
    openLayerTypeMap.set("temperature", false);
    openLayerTypeMap.set("airPressure", false);
    openLayerTypeMap.set("tides", false);
    openLayerTypeMap.set("rainProbability", false);
  } else if (popupType === "rain") {
    openLayerTypeMap.set("rain", false);
  } else if (popupType === "airPressurenot") {
    openLayerTypeMap.set("airPressure", true);
    openLayerTypeMap.set("wind", false);
    openLayerTypeMap.set("temperature", false);
    openLayerTypeMap.set("rain", false);
    openLayerTypeMap.set("tides", false);
    openLayerTypeMap.set("rainProbability", false);
  } else if (popupType === "airPressure") {
    openLayerTypeMap.set("airPressure", false);
  } else if (popupType === "tidesnot") {
    openLayerTypeMap.set("tides", true);
    openLayerTypeMap.set("airPressure", false);
    openLayerTypeMap.set("wind", false);
    openLayerTypeMap.set("temperature", false);
    openLayerTypeMap.set("rain", false);
    openLayerTypeMap.set("rainProbability", false);
  } else if (popupType === "tides") {
    openLayerTypeMap.set("tides", false);
  }
  else if (popupType === "rainProbabilitynot") {
    openLayerTypeMap.set("rainProbability", true);
    openLayerTypeMap.set("airPressure", false);
    openLayerTypeMap.set("wind", false);
    openLayerTypeMap.set("temperature", false);
    openLayerTypeMap.set("rain", false);
    openLayerTypeMap.set("tides", false);
  } else if (popupType === "rainProbability") {
    openLayerTypeMap.set("rainProbability", false);
  }
  else if (popupType === "satellite") {
    openLayerTypeMap.set(popupType, false);
  } else if (popupType === "satellite not") {
    openLayerTypeMap.set("satellite", true);
  } else if (popupType === "pressure") {
    openLayerTypeMap.set(popupType, true);
  } else if (popupType === "pressure not") {
    openLayerTypeMap.set("pressure", false);
  } else if (popupType === "flood") {
    openLayerTypeMap.set(popupType, true);
  } else if (popupType === "floodnot") {
    openLayerTypeMap.set("flood", false);
  } else {
    if (openLayerTypeMap.has(popupType)) {
      const currentValue = openLayerTypeMap.get(popupType);
      if (currentValue === true) {
        openLayerTypeMap.set(popupType, false);
      } else {
        openLayerTypeMap.set(popupType, true);
      }
    } else {
      openLayerTypeMap.set(popupType, true);
    }
  }

  const activeKeys = Array.from(openLayerTypeMap.entries())
    .filter(([key, value]) => value === true)
    .map(([key]) => key);

  if (
    activeKeys.length !== 0 &&
    //-------------------add becouse no timedata
    (activeKeys.includes("wind") ||
      activeKeys.includes("temperature") ||
      activeKeys.includes("rain") ||
      activeKeys.includes("airPressure") ||
      activeKeys.includes("flood") ||
      activeKeys.includes("pressure") ||
      activeKeys.includes("satellite") ||
      activeKeys.includes("tides")) ||
    activeKeys.includes("rainProbability")
  ) {

    timeLineShow = true;
  } else {
    timeLineShow = false;
  }

  //console.log("Updated openLayerTypeMap:", openLayerTypeMap);

  if (popupType === "wind") {
    markerPopupWindRemove = popupType;
  } else if (popupType === "temperature") {
    markerPopupTempRemove = popupType;
  } else if (popupType === "rain") {
    markerPopupRainRemove = popupType;
  } else if (popupType === "airPressure") {
    markerPopupAirRemove = popupType;
  } else if (popupType === "tides") {
    markerPopupTidesRemove = popupType;
  } else if (popupType === "rainProbability") {
    markerPopupRainProbabilityRemove = popupType;
  }


  if (
    markerPopupWindRemove === "wind" &&
    markerPopupTempRemove === "temperature" &&
    markerPopupRainRemove === "rain" &&
    markerPopupAirRemove === "airPressure" &&
    markerPopupTidesRemove === "tides" &&
    markerPopupRainProbabilityRemove === "rainProbability"
  ) {
    markerPopupLocationWeather = "close";
  } else {
    markerPopupLocationWeather = "open";
  }
}

export default function MainWindow() {
  const { layout } = useLayout();
  const {
    clickmarker,
    setMarker,
    atmosphericRivers,
    cyclones,
    tonardo,
    droughts,
    jetStreams,
    stormSurges,
    dustStorms,
  } = useAllWeatherContext();
  const { EWSOpenSidebarMap } = useEWSContext();
  const { HzOpenSidebarMap } = useHzContext();
  const { setIsMinLoad, isMinLoad } = useAirQualityContext();
  const mapRef = useRef<HTMLDivElement>(null);
  const mapRefHide = useRef<HTMLDivElement>(null);
  const popupRef = useRef<HTMLDivElement>(null);
  const closerRef = useRef<HTMLAnchorElement>(null);
  const map = useMap();
  const [showWind, setShowWind] = useState("");
  const [hdms, setHdms] = useState("");
  const [open, setOpen] = useState<boolean>(false);
  const [floodSimulationPopup, setFloodSimulationPopup] =
    useState<boolean>(false);
  const [tornadoSimulationPopup, setTornadoSimulationPopup] =
    useState<boolean>(false);
  const [heavyRainfallPopup, setHeavyRainfallPopup] = useState<boolean>(false);
  const [markeType, setMarkeType] = useState("");
  const [simulationName, setSimulationName] = useState("");
  const [showModel, setShowModel] = useState(false);
  const [showMessure, setShowMessure] = useState(false);
  // const [weatherLayer, setWeatherLayer] = useState<string>("");
  const [TimeLayer, setTimeLayer] = useState<string>("");
  const [getValueFromLefSideMenu, setValueFromLefSideMenu] =
    useState<string>("main");
  const [getTimeSlotValueFromTimelines, setTimeSlotValueFromTimelines] =
    useState<string>("");
  const [getDateSlotValueFromTimelines, setDateSlotValueFromTimelines] =
    useState<string>("");
  const [playTimerMain, setPlayTimerMain] = useState<boolean>(true);
  const [getTimeRangePopupFrom, setTimeRangePopupFrom] = useState<string>("");
  const [getTimeRangePopupTo, setTimeRangePopupTo] = useState<string>("");
  const [showTimeRangeNotification, setShowTimeRangeNotification] =
    useState<boolean>(false);
  const [showPopupDropDown, setShowPopupDropDown] = useState<boolean>(false);
  const [showPopupDropDownSensor, setShowPopupDropDownSensor] =
    useState<boolean>(false);
  const [clickedHzIncidentMap, setClickedHzIncidentMap] =
    useState<boolean>(false);
  const [clickedEWSMap, setClickedEWSMap] = useState<boolean>(false);
  const [showAddLayer, setShowAddLayer] = useState<boolean>(false);
  const [getTimeIndexCount, setTimeIndexCount] = useState<number>();
  const [sendTimeIndexCount, setSendTimeIndexCount] = useState<number>();
  const [getVoiceRecognitionValue, setVoiceRecognitionValue] =
    useState<string>("");
  const [openVoiceRecognitionConsole, setVoiceRecognitionConsole] =
    useState<boolean>(false);
  const [selectedModel, setSelectedModel] = useState("ECMWF");
  const [voiceMessage, setVoiceMessage] = useState("");
  const [timelineData, setTimelineData] = useState<TimelineElement[]>([]);
  const [toggleTimeline, setToggleTimeline] = useState(false);
  const { theme } = useTheme();
  const [isSummeryPopupOpen, setIsSummeryPopupOpen] = useState<boolean>(true);
  const [earlyWarningsFromChild, setEarlyWarningsFromChild] = useState<
    earlyWarning[]
  >([]);
  const [hzDatafromSummery, setHzDatafromSummery] = useState<hzIncidents[]>([]);
  const [isSummaryMoreDetailsOpen, setIsSummaryMoreDetailsOpen] =
    useState<boolean>(false);
  const [isEwsServerityOpen, setIsEwsServerityOpen] = useState<boolean>(false);
  const [detailsByTypeOpen, setDetailsByTypeOpen] = useState<boolean>(false);
  const [filterEws, setFilterEws] = useState<earlyWarning[]>([]);
  const [filterEwsByType, setFilterEwsByType] = useState<earlyWarning[]>([]);
  const [filterHzByType, setFilterHzByType] = useState<hzIncidents[]>([]);
  const [isTerminalOpen, setIsTerminalOpen] = useState<boolean>(false);
  const [terminalCommands, setTerminalCommands] = useState<string[]>([]);
  const [notifications, setNotifications] = useState<NotificationType[]>([]);
  const [getOpenModular, setOpenModular] = useState<string>("notOpenedModular");
  const closeModular = () => setOpenModular("notOpenedModular");
  const openModularArraysNotNull = () => setOpenModular("modularOpened");
  const [getRiverSensorRender, setRiverSensorRender] = useState(false);
  const [getAirQualityRender, setAirQualityRender] = useState(false);
  const [getRenderEWS, setrenderEWS] = useState(false);
  const [getRenderHz, setrenderHz] = useState(false);
  const [getSensorType, setSensorType] = useState<string>("");
  const [getSummeryType, setSummeryType] = useState<string>("");
  const [minMenuRain, setMinMenuRain] = useState<boolean>(true);
  const [minMenuRiver, setMinMenuRiver] = useState<boolean>(true);
  const [minMenuAir, setMinMenuAir] = useState<boolean>(true);
  const [minMenuAirLeft, setMinMenuAirLeft] = useState<boolean>(true);
  const [minMenuRiverLeft, setMinMenuRiverLeft] = useState<boolean>(true);
  const [minMenuRainLeft, setMinMenuRainLeft] = useState<boolean>(true);
  const [getUser, setUser] = useState<string>();
  const [windowHeight, setWindowHeight] = useState(window.innerHeight);
  const [isSideMenuOpen, setIsSideMenuOpen] = useState<boolean>(false);
  const [newImageUrl, setImageUrl] = useState<string>(ecmwf2);
  const [infoSourceAir, setInfoSourceAir] = useState<string>("");
  const [infoSourceRiver, setInfoSourceRiver] = useState<string>("");
  const [infoSourceRain, setInfoSourceRain] = useState<string>("");
  const [weatherModelUrl, setWeatherModelUrl] = useState<string>("https://www.ecmwf.int/en/forecasts");
  const [voiceCommand, setVoiceCommand] = useState<string>("");
  const [locationCoordinates, setLocationCoordinates] = useState<Coordinate>();


  const handleEarlyWarningData = (data: earlyWarning[]) => {
    setEarlyWarningsFromChild(data);
  };

  const handleHzData = (data: hzIncidents[]) => {
    setHzDatafromSummery(data);
  };

  const handleSummeryClose = () => {
    setIsSummaryMoreDetailsOpen(false);
  };

  const handleEWSSeverityClose = () => {
    setIsEwsServerityOpen(false);
  };

  const handleDetailsByTypeClose = () => {
    setDetailsByTypeOpen(false);
  };

  const handleFilteredEWSWarnings = (filteredWarnings: earlyWarning[]) => {
    setFilterEws(filteredWarnings);
  };

  const handleFilteredEWSWarningsByType = (
    filteredWarningsByType: earlyWarning[]
  ) => {
    setFilterEwsByType(filteredWarningsByType);
  };

  const handleFilteredHzByType = (filteredHzByType: hzIncidents[]) => {
    setFilterHzByType(filteredHzByType);
  };

  const PopupDropDown = () => {
    setShowPopupDropDown(true);
  };

  const AddLayerDropDown = () => {
    // setShowAddLayer(true);
    setShowAddLayer((prevState) => !prevState);
  };

  const handleMouseEnterModelType = () => {
    setShowModel(true);
  };

  const handleMouseLeaveModelType = () => {
    setShowModel(false);
  };

  const handleMouseMessureTypes = () => {
    setShowMessure(true);
  };

  const handleMouseLeaveMessureTypes = () => {
    setShowMessure(false);
  };

  const handleOpenConsole = (simulationName: string) => {
    setSimulationName(simulationName);
  };

  const handleToggle = () => {
    setOpen(!open);
  };

  const updateParentState = (newValue: boolean) => {
    setOpen(newValue);
  };

  const handleClickedHzIncident = (clicked: boolean) => {
    setClickedHzIncidentMap(clicked);
  };

  const handleClickedEWS = (clicked: boolean) => {
    setClickedEWSMap(clicked);
  };

  const handleTimelineData = (data: TimelineElement[]) => {
    setTimelineData(data);
  };

  useEffect(() => { }, [voiceMessage]);

  useEffect(() => {
    const handleResize = () => setWindowHeight(window.innerHeight);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

    useEffect(() => { 
     console.log("------useEffect--------",TimeLayer)
  }, [TimeLayer]);

       console.log("-----outside--------",TimeLayer)

  useEffect(() => {
    if (showPopupDropDownSensor && windowHeight > 800) {
      setIsMinLoad(true);
    } else if (showPopupDropDownSensor && windowHeight < 800) {
      setIsMinLoad(false);
    }
  }, [showPopupDropDownSensor]);

  useEffect(() => {
    if (selectedModel === "ICON") {
      clickModel = "ICON";
    } else {
      clickModel = "ECMWF";
    }
  }, [selectedModel]);

  useEffect(() => { }, [timeLineShow]);

  useEffect(() => {
    const entries = Array.from(openLayerTypeMap.entries());
    const relevantEntries = entries.filter(
      ([key]) =>
        key === "earlywarning" || key === "hzIncidents" || key === "satellite"
    );
    const allFalse = relevantEntries.every(([key, value]) => value === false);

    if (allFalse) {
      setShowPopupDropDown(false);
    }

    let imageUrl = "";
    let modelUrl = ""

    openLayerTypeMap.forEach((value, key) => {
      if (value === true) {
        if (
          key === "wind" ||
          key === "temperature" ||
          key === "rain" ||
          key === "airPressure" ||
          key === "tides" ||
          key === "rainProbability"
        ) {
          if (selectedModel === "ECMWF") {
            imageUrl = ecmwf2;
            modelUrl = "https://www.ecmwf.int/en/forecasts";
          } else if (selectedModel === "ICON") {
            imageUrl = iconImage;
            modelUrl = "https://www.icon-model.org/";
          }
        } else if (key === "satellite") {
          imageUrl = eumetsat;
          modelUrl = "https://www.eumetsat.int/";
        } else if (key === "airquality") {
          return setInfoSourceAir("Source: NBRO ,");
        } else if (key === "river") {
          return setInfoSourceRiver("Source: Irrigation Department ,");
        } else if (key === "rainfall") {
          return setInfoSourceRain("Source: NBRO ,");
        }
      } else {
        if (key === "airquality") {
          return setInfoSourceAir("");
        } else if (key === "river") {
          return setInfoSourceRiver("");
        } else if (key === "rainfall") {
          return setInfoSourceRain("");
        }
      }
    });
    setImageUrl(imageUrl);
    setWeatherModelUrl(modelUrl);
  }, [openLayerTypeMap.entries()]);

  useEffect(() => {
    setShowWind(name1);
    setMarkeType(markerPopup);

    if (markerPopup === "earlywarning" || markerPopup === "earlywarning not") {
      const info = document.getElementById("info");
      let currentFeature: Feature<any> | null | undefined = undefined;

      const displayFeatureInfo = (
        pixel: [number, number] | Pixel,
        target: HTMLElement
      ) => {
        const feature = target.closest(".ol-control")
          ? undefined
          : map.forEachFeatureAtPixel(pixel, function (feature) {
            return feature as Feature<any> | undefined; // Explicitly casting
          });

        if (
          feature &&
          info &&
          (markerPopup === "earlywarning" || markerPopup === "earlywarning not")
        ) {
          const ecoName = feature.get("ECO_NAME");
          const description = feature.get("BIOME_NAME");
          const issueTime = feature.get("REALM");
          const endTime = feature.get("NNH_NAME");
          // Check if ECO_NAME is not null or undefined
          if (ecoName) {
            info.style.left = pixel[0] + "px";
            info.style.top = pixel[1] + "px";
            if (feature !== currentFeature) {
              info.style.visibility = "visible";

              // Set innerHTML with ecoName and description
              info.innerHTML = `
              <div style="text-align: center; margin-bottom: 10px; font-size:14px;">
              <strong>${ecoName}</strong>
              </div>
              <div style="text-align: left; font-size:12px;">
              <div   style="margin-bottom: 3px;">${description ? description : ""
                }</div>
              <div style="margin-bottom: 3px;">IssueTime: ${issueTime ? issueTime : ""
                }</div>
              <div>EndTime: ${endTime ? endTime : ""}</div>
              </div>
              `;
            }
          } else {
            // Hide info if ECO_NAME is null or undefined
            info.style.visibility = "hidden";
          }
        } else if (info) {
          info.style.visibility = "hidden";
        }
        currentFeature = feature ?? null;
      };

      map.on("pointermove", function (evt) {
        if (evt.dragging) {
          if (info) {
            info.style.visibility = "hidden";
          }
          currentFeature = undefined;
          return;
        }
        const pixel = map.getEventPixel(evt.originalEvent);
        displayFeatureInfo(pixel, evt.originalEvent.target);
      });

      map.getTargetElement().addEventListener("pointerleave", function () {
        currentFeature = undefined;
        if (info) {
          info.style.visibility = "hidden";
        }
      });
    }
  }, [markerPopup]);

  useEffect(() => { }, [setValueFromLefSideMenu]);

  useEffect(() => {
    clkMarker = clickmarker;
  }, [clickmarker]);

  useEffect(() => {
    if (mapRef.current) {
      map.setTarget(mapRef.current);
      map.updateSize();
    }
    if (!popupRef.current || !closerRef.current) return;
    const container = popupRef.current;
    const closer = closerRef.current;
    const overlay = new Overlay({
      element: container,
      autoPan: {
        animation: {
          duration: 250,
        },
      },
    });
    map.addOverlay(overlay);
    closer.onclick = function () {
      overlay.setPosition(undefined);
      closer.blur();
      setOpen(false);
      return false;
    };

    const singleClickKey = map.on("singleclick", async function (evt) {
      if (
        (TimeLayer === "windnot" ||
          TimeLayer === "temperaturenot" ||
          TimeLayer === "rainnot" ||
          TimeLayer === "airPressurenot" ||
          TimeLayer === "tidesnot" ||
          TimeLayer === "rainProbabilitynot") &&
        markerPopupLocationWeather === "open" &&
        clkMarker === "notClickMarker"
      ) {
 console.log("------tp--------",TimeLayer)
        const pixel = map.getEventPixel(evt.originalEvent);
        const coordinate = map.getCoordinateFromPixel(pixel);
        setLocationCoordinates(coordinate);
        const longitude = coordinate[0];
        const latitude = coordinate[1];

        const convertedCodinates = proj4("EPSG:3857", "EPSG:4326", [
          longitude,
          latitude,
        ]);

        const delta = 0.001;
        const minX = convertedCodinates[0] - delta;
        const maxX = convertedCodinates[0] + delta;
        const minY = convertedCodinates[1] - delta;
        const maxY = convertedCodinates[1] + delta;
        const colomboLonLat = [longitude, latitude];
        if (globalLayers) {
          const wmsSource = globalLayers.getSource()!;
          const QUERY_LAYERS = wmsSource.getParams().LAYERS;
          const url =
            "https://wms.tecxal.com/visura/weatherwmseagle?SERVICE=WMS&VERSION=1.1.1&REQUEST=GetFeatureInfo&FORMAT=image%2Fjpeg&TRANSPARENT=true&QUERY_LAYERS=" +
            encodeURIComponent(QUERY_LAYERS) +
            "&STYLES&LAYERS=" +
            encodeURIComponent(QUERY_LAYERS) +
            "&exceptions=application%2Fvnd.ogc.se_inimage&INFO_FORMAT=application/json&FEATURE_COUNT=50&X=50&Y=50&SRS=EPSG%3A4326&WIDTH=101&HEIGHT=101&BBOX=" +
            encodeURIComponent(minX + "," + minY + "," + maxX + "," + maxY);

          if (url) {
            try {
              const response = await fetch(url);
              const data = await response.json();
              if (data.features && data.features.length > 0) {
                const featureInfo = data.features[0].properties;
                const textColor = "var(--text-color)";
                if (TimeLayer === "temperaturenot") {
                  const temperature = featureInfo.GRAY_INDEX;
                  let temperatureInCelsius;

                  if (clickModel === "ECMWF") {
                    temperatureInCelsius = temperature - 273.15;
                  } else if (clickModel === "ICON") {
                    temperatureInCelsius = temperature;
                  }
                  // const temperatureInCelsius = temperature - 273.15;
                  const roundedTemperatureInCelsius =
                    Math.round(temperatureInCelsius);
                  const temperatureWithUnit = `${roundedTemperatureInCelsius}°C`;
                  const content = container.querySelector(
                    "#popup-content"
                  ) as HTMLDivElement;
                  content.innerHTML = `<br><code  style="color:${textColor};">${temperatureWithUnit}</code>`;
                } else if (TimeLayer === "rainnot") {
                  const rain = featureInfo.GRAY_INDEX;
                  const rainmm = rain * 1000;
                  const roundedRain = Math.round(rainmm);
                  const rainUnit = `${roundedRain} mm`;
                  const content = container.querySelector(
                    "#popup-content"
                  ) as HTMLDivElement;
                  content.innerHTML = `<br><code  style="color:${textColor};">${rainUnit}</code>`;
                } else if (TimeLayer === "airPressurenot") {
                  const pressure = featureInfo.GRAY_INDEX;
                  const roundedPressurehpa = pressure / 100;
                  const roundedPressure = Math.round(roundedPressurehpa);
                  const pressureUnit = `${roundedPressure} hPa`;
                  const content = container.querySelector(
                    "#popup-content"
                  ) as HTMLDivElement;
                  content.innerHTML = `<br><code  style="color:${textColor};">${pressureUnit}</code>`;
                } else if (TimeLayer === "windnot") {
                  const windSpeed = featureInfo.GRAY_INDEX;
                  const roundedWindSpeed = Math.round(windSpeed);
                  const windSpeedWithUnit = `${roundedWindSpeed} m/s  `;

                  let angle;
                  if (url) {
                    try {
                      const response = await fetch(
                        url.replaceAll("dsuvspeed", "uvdir")
                      );
                      const data = await response.json();
                      if (data.features && data.features.length > 0) {
                        const featureInfo = data.features[0].properties;
                        angle = featureInfo.GRAY_INDEX;
                      }
                    } catch (error) {
                      console.error("Error fetching GetFeatureInfo:", error);
                    }
                  }

                  // Display wind speed and direction in the popup
                  const content = container.querySelector(
                    "#popup-content"
                  ) as HTMLDivElement;
                  content.innerHTML = `<br>
                    <code style="color: ${textColor}; margin-right: 10px;">${windSpeedWithUnit}</code>
                    <div id="wind-arrow-container" style="display: inline-block; transform: rotate(${angle}deg);">
                    <img src="${arrow}" alt="Wind Direction Arrow" style="width:12px; height: 12px; color: ${textColor};"/> </div>`;
                } else if (TimeLayer === "tidesnot") {
                  const tidesHigh = featureInfo.GRAY_INDEX;
                  let pressureUnit;

                  if (tidesHigh === 9999) {
                    pressureUnit = "0 m";
                  } else {
                    // Remove the division by 100 since you're already getting small decimal values
                    const roundedValue = parseFloat(tidesHigh.toString()).toFixed(2);
                    pressureUnit = `${roundedValue} m`;
                  }

                  const content = container.querySelector("#popup-content") as HTMLDivElement;
                  content.innerHTML = `<br><code style="color:${textColor};">${pressureUnit}</code>`;
                } else if (TimeLayer === "rainProbabilitynot") {
                  const rainProbability = featureInfo.GRAY_INDEX;
                 
                  const rainProbabilitymm = rainProbability *3600;
                  const roundedRainProbability = Math.round(rainProbabilitymm);
                  const rainProbabilityUnit = `${roundedRainProbability} mm/h`;
                  const content = container.querySelector(
                    "#popup-content"
                  ) as HTMLDivElement;
                  content.innerHTML = `<br><code  style="color:${textColor};">${rainProbabilityUnit}</code>`;
                }
                overlay.setPosition(coordinate);
              } else {
                console.log("No feature data found");
              }
            } catch (error) {
              console.error("Error fetching GetFeatureInfo:", error);
            }
          }
        }
      }
      setMarker("notClickMarker");
    });

    return () => {
      unByKey(singleClickKey); // Clean up the event listener
      map.removeOverlay(overlay);
    };
  }, [map, markerPopup, clkMarker]);

  const handleCloseFloodSimulationPopup = () => {
    setFloodSimulationPopup(false);
  };

  const handleCloseHeavyRainfallPopup = () => {
    setHeavyRainfallPopup(false);
  };

  const handleCloseTornadoSimulationPopup = () => {
    setTornadoSimulationPopup(false);
  };

  useEffect(() => {
    if (
      getValueFromLefSideMenu ||
      getDateSlotValueFromTimelines ||
      getTimeSlotValueFromTimelines
    ) {
      setSendTimeIndexCount(getTimeIndexCount);
    }
  }, [
    toggleTimeline,
    getValueFromLefSideMenu,
    getDateSlotValueFromTimelines,
    getTimeSlotValueFromTimelines,
    getTimeIndexCount,
  ]);

  useEffect(() => {
    if (getVoiceRecognitionValue) {
      // console.log("Voice Recognition Value : " + getVoiceRecognitionValue);
    }
  }, [getVoiceRecognitionValue]);


  useEffect(() => { }, [locationCoordinates]);


  const [popups, setPopups] = useState<PopupsListType[]>([
    { name: "sensor one", id: "1" },

  ]);

  useEffect(() => {
    if (getOpenModular === "modularOpened") {
      setIsSideMenuOpen(EWSOpenSidebarMap.size > 0);
    }
  }, [EWSOpenSidebarMap]);

  useEffect(() => {
    if (getOpenModular === "modularOpened") {
      setIsSideMenuOpen(HzOpenSidebarMap.size > 0);
    }
  }, [HzOpenSidebarMap]);

  useEffect(() => {
    if (getOpenModular === "modularOpened") {
      setIsSideMenuOpen(true);
    }
    if (
      !detailsByTypeOpen &&
      !isEwsServerityOpen &&
      !isSummaryMoreDetailsOpen &&
      getOpenModular === "modularOpened"
    ) {
      setIsSideMenuOpen(false);
    }
  }, [detailsByTypeOpen, isEwsServerityOpen, isSummaryMoreDetailsOpen]);

  useEffect(() => { }, [isSideMenuOpen]);

  useEffect(() => {
    if (!floodSimulationPopup && getOpenModular === "modularOpened") {
      setIsSideMenuOpen(false);
    }
  }, [floodSimulationPopup]);

  const closeAllSum = () => {
    if (getOpenModular === "modularOpened") {
      setIsSummaryMoreDetailsOpen(false);
      setIsEwsServerityOpen(false);
      setDetailsByTypeOpen(false);
    }
  };

  const openSimulation = () => {
    setFloodSimulationPopup(true);
  };

  const openSimulationTornado = () => {
    setTornadoSimulationPopup(true);
  };

  const handleButtonClickMinMenuRain = (open: boolean) => {
    setMinMenuRain(open);
  };

  const handleButtonClickMinMenuRiver = (open: boolean) => {
    setMinMenuRiver(open);
  };

  const handleButtonClickMinMenuAir = (open: boolean) => {
    setMinMenuAir(open);
  };

  const clickMinMenuAirleft = (open: boolean) => {
    setMinMenuAirLeft(open);
  };

  const clickMinMenuRiverleft = (open: boolean) => {
    setMinMenuRiverLeft(open);
  };

  const clickMinMenuRainleft = (open: boolean) => {
    setMinMenuRainLeft(open);
  };

  useEffect(() => { }, [minMenuRain]);
  useEffect(() => { }, [minMenuRiver]);
  useEffect(() => { }, [minMenuAir]);
  useEffect(() => { }, [minMenuAirLeft]);
  useEffect(() => { }, [minMenuRiverLeft]);
  useEffect(() => { }, [minMenuRainLeft]);

  useEffect(() => {
    const storedUser = localStorage.getItem("username");
    if (storedUser) {
      try {
        const username = storedUser;
        setUser(username);
      } catch (error) {
        console.error("Error parsing JSON from localStorage:", error);
      }
    }
  }, []);

  return (
    <div className="App">
      <div className={`map-container ${theme}`}>
        <div id="map" className={`map ${theme}`} ref={mapRef}>
          <div id="info" className="info"></div>
          <div ref={popupRef} className="ol-popup">
            <a
              href="#"
              ref={closerRef}
              className="ol-popup-closer"
              style={{ display: `${open ? "none" : "flex"}` }}
            >
              <CloseIcon style={{ width: `80%`, color: `white` }} />
            </a>
            <div className={`location-dot animate`}>
              <div className={`location-dot-ring`}></div>
            </div>
            <div
              className="pop-description"
              style={{ display: `${open ? "none" : "flex"}` }}
            >
              <div className={`line`}></div>
              <span id="popup-content">{hdms}</span>
              <div
                className={`more-details-btn`}
                id="flag-close-btn"
                onClick={handleToggle}
                onTouchStart={handleToggle}
              >
                <MoreHorizIcon
                  style={{ width: `80%`, color: `var(--text-color)` }}
                />
              </div>
            </div>
          </div>
        </div>
        <RightSideMenu
          menuStatus={isSideMenuOpen}
          getModularOpened={getOpenModular}
          closeModular={closeModular}
          setMenuStatus={setIsSideMenuOpen}
          popups={popups}
          setPopups={setPopups}
          getRiverSensorRender={getRiverSensorRender}
          getAirQualityRender={getAirQualityRender}
          getSensorType={getSensorType}
          getRenderEWS={getRenderEWS}
          openModularArraysNotNull={openModularArraysNotNull}
          getRenderHz={getRenderHz}
          terminalCommands={setTerminalCommands}
          terminalState={setIsTerminalOpen}
          notifications={setNotifications}
          detailsByTypeOpen={detailsByTypeOpen}
          earlyWarningsFromChild={filterEwsByType}
          filterHzByType={filterHzByType}
          filterEws={filterEws}
          isEwsServerityOpen={isEwsServerityOpen}
          isSummaryMoreDetailsOpen={isSummaryMoreDetailsOpen}
          earlyWarningsFull={earlyWarningsFromChild}
          hzDatafromSummery={hzDatafromSummery}
          ewSeverityWindow={setIsEwsServerityOpen}
          typeWindow={setDetailsByTypeOpen}
          moreDetailWindow={setIsSummaryMoreDetailsOpen}
          handleClosePopup={handleCloseFloodSimulationPopup}
          runButtonOnClick={handleOpenConsole}
          onClose={handleSummeryClose}
          onCloseByType={handleDetailsByTypeClose}
          onCloseBySeverity={handleEWSSeverityClose}
          getSummeryType={getSummeryType}
          closeAllSum={closeAllSum}
          openSimulation={openSimulation}
          floodSimulationPopup={floodSimulationPopup}
          timeLineHour={getTimeSlotValueFromTimelines}
          timeLineDate={getDateSlotValueFromTimelines}
          selectModel={selectedModel}
          openModular={openModularArraysNotNull}
          openTornadoSimulation={openSimulationTornado}
        />
        {!isSideMenuOpen && (
          <div className={`buttonWrapper`}>
            <FontAwesomeIcon
              className="sideMenuOpenButton"
              size="lg"
              icon={faCircleChevronLeft}
              onClick={(e) => setIsSideMenuOpen(true)}
              onTouchStart={(e) => setIsSideMenuOpen(true)}
            />
          </div>
        )}
        <div>
          {timeLineShow && (
            <TimelineService
              passSelectedDateSlotValue={(value) => {
                setDateSlotValueFromTimelines(value);
                setToggleTimeline((prev) => !prev);
              }}
              passSelectedTimeSlotValue={setTimeSlotValueFromTimelines}
              {...(getValueFromLefSideMenu === "Satellite Imagery" && {
                From: getTimeRangePopupFrom,
                To: getTimeRangePopupTo,
              })}
              {...(getValueFromLefSideMenu === "Reported Incidents" && {
                From: getTimeRangePopupFrom,
                To: getTimeRangePopupTo,
              })}
              passTimeIndexCount={setTimeIndexCount}
              selectModel={selectedModel}
              getValueFromLefSideMenu={getValueFromLefSideMenu}
              openLayerTypeMap={openLayerTypeMap}
              passTimelineData={handleTimelineData}
              getVoiceRecognitionValue={getVoiceRecognitionValue}
            />
          )}
        </div>
        <div
          style={{
            position: "absolute",
            top: timeLineShow ? "70px" : "10px",
            left: "0.5%",
            zIndex: 990,
          }}
        >
          {isSummeryPopupOpen && (
            <SummaryComp
              windowState={setIsSummeryPopupOpen}
              moreDetailWindow={setIsSummaryMoreDetailsOpen}
              handleEarlyWarningData={handleEarlyWarningData}
              handleHzData={handleHzData}
              ewSeverityWindow={setIsEwsServerityOpen}
              onFilteredWarnings={handleFilteredEWSWarnings}
              onFilteredWarningsByType={handleFilteredEWSWarningsByType}
              typeWindow={setDetailsByTypeOpen}
              onFilteredHzByType={handleFilteredHzByType}
              openModular={setOpenModular}
              summeryType={setSummeryType}
            />
          )}
        </div>
        <div
          style={{
            position: "absolute",
            top: timeLineShow ? "70px" : "10px",
            right: "0.5%",
            zIndex: 1,
            opacity: 0.5,
            color: "var(--text-color)",
          }}
        >
          Developer mode
        </div>
        <div
          style={{
            position: "absolute",
            bottom: "10px",
            right: "0.5%",
            zIndex: 1,
            opacity: 0.5,
            color: "var(--text-color)",
            fontSize: "10px",
          }}
        ><a href="https://tecxal.com/" target="_blank" rel="noopener noreferrer" style={{ color: "var(--text-color)", textDecoration: "none", opacity: 0.5, }}>
            Powered by Tecxal Systems
          </a>
        </div>
        <div
          style={{
            position: "absolute",
            bottom: "25px",
            right: "0.5%",
            color: "var(--text-color)",
            fontSize: "10px",
            opacity: 0.5,
            display: "flex",
            alignItems: "center",
            gap: "8px",
          }}
        >
          <div style={{ paddingBottom: "1px", display: "flex", gap: "0px" }}>
            {infoSourceAir && (
              <a
                href="https://nbro.gov.lk/index.php?lang=en"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "var(--text-color)", textDecoration: "none" }}
              >
                {infoSourceAir}
              </a>
            )}

            {infoSourceRiver && (
              <a
                href="https://www.irrigation.gov.lk/"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "var(--text-color)", textDecoration: "none" }}
              >
                {infoSourceRiver}
              </a>
            )}

            {infoSourceRain && (
              <a
                href="http://www.rainfall.nbro.gov.lk:8080/mapforweb/all/mapview.aspx"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "var(--text-color)", textDecoration: "none" }}
              >

                {infoSourceAir !== "" ? `${infoSourceRain.replace(/,/g, '')} (Rain), ` : infoSourceRain}
              </a>
            )}
          </div>

          {newImageUrl && (
            <a href={weatherModelUrl} target="_blank" rel="noopener noreferrer">
              <img
                src={newImageUrl}
                style={{ width: "60px", height: "20px", borderRadius: "5px" }}
              />
            </a>
          )}
        </div>
        <div
          style={{
            position: "absolute",
            top: "15%",
            left: "1%",
            zIndex: "99999",
          }}
        >
          {showTimeRangeNotification && (
            <TimeRangeNotification
              onCloseTimeRangeNotification={() =>
                setShowTimeRangeNotification(false)
              }
            />
          )}
        </div>
        <div
          style={{ position: "absolute", top: "30%", left: "0%", width: "0%" }}
        >
          {floodSimulationPopup && layout === "hawk eye" && (
            <SimulationPopup
              terminalState={setIsTerminalOpen}
              terminalCommands={setTerminalCommands}
              notifications={setNotifications}
              handleClosePopup={handleCloseFloodSimulationPopup}
              runButtonOnClick={handleOpenConsole}
            />
          )}
        </div>
        <div
          style={{ position: "absolute", top: "30%", left: "0%", width: "0%" }}
        >
          {tornadoSimulationPopup && layout === "hawk eye" && (
            <TornadoSimulationComp
              terminalState={setIsTerminalOpen}
              terminalCommands={setTerminalCommands}
              notifications={setNotifications}
              handleClosePopup={handleCloseTornadoSimulationPopup}
              runButtonOnClick={handleOpenConsole}
            />
          )}
        </div>
        {isTerminalOpen && (
          <TerminalPopup
            windowState={setIsTerminalOpen}
            commands={terminalCommands}
            simulationName={simulationName}
          />
        )}
        {notifications.length > 0 && (
          <NotificationPopup
            notifications={notifications}
            setNotifications={setNotifications}
          />
        )}
        <div
          style={{
            position: "absolute",
            top: "24%",
            left: "10vw",
            width: "0%",
          }}
        >
          {heavyRainfallPopup && (
            <ExtremeHeavyRainfall
              isVisible={heavyRainfallPopup}
              handleClosePopup={handleCloseHeavyRainfallPopup}
            />
          )}
        </div>
        <div style={{ position: "absolute", top: "29%", left: "1vw" }}>
          <LeftSideMenu
            // setWeatherLayer={setWeatherLayer}
            setTimeLayer={setTimeLayer}
            layerValueFromLeftSideMenu={setValueFromLefSideMenu}
            showTimeRangeExceedNotification={() => {
              setShowTimeRangeNotification(true);
            }}
            passStartHazardDuration={setTimeRangePopupFrom}
            passToHazardDuration={setTimeRangePopupTo}
            openPopupLeftSideMenu={PopupDropDown}
            clickedHzIncident={clickedHzIncidentMap}
            showPopupDropDown={showPopupDropDown}
            getValueFromLefSideMenu={getValueFromLefSideMenu}
            clickedEWS={clickedEWSMap}
            timeLineHour={getTimeSlotValueFromTimelines}
            timeLineDate={getDateSlotValueFromTimelines}
            timeIndexCount={sendTimeIndexCount}
            selectModel={selectedModel}
            getVoiceRecognitionValue={getVoiceRecognitionValue}
            timelineData={timelineData}
            openModular={setOpenModular}
            setRiverSensorRender={setRiverSensorRender}
            sensorType={setSensorType}
            renderAirQualitySensor={setAirQualityRender}
            sidebarOpen={setIsSideMenuOpen}
            closePopupDropDown={() => {
              setShowPopupDropDownSensor(true);
            }}
            showPopupDropDownSensor={showPopupDropDownSensor}
            openLayerTypeMap={openLayerTypeMap}
            minMenuRain={minMenuRain}
            minMenuRiver={minMenuRiver}
            minMenuAir={minMenuAir}
            minMenuAirLeft={clickMinMenuAirleft}
            minMenuRiverLeft={clickMinMenuRiverleft}
            minMenuRainLeft={clickMinMenuRainleft}
            openPopupDropDown={() => {
              setShowPopupDropDownSensor(false);
            }}
            miniMenuload={isMinLoad}
          />
        </div>
        {showPopupDropDownSensor && windowHeight <= 800 && (
          <div
            style={{
              position: "absolute",
              top: "30%",
              left: showPopupDropDown ? "40vw" : "15vw",
              opacity: showPopupDropDownSensor ? 1 : 0,
              pointerEvents: showPopupDropDownSensor ? "auto" : "none",
              transition: "opacity 0.3s ease",
            }}
          >
            <MinMenu
              closePopupDropDown={() => {
                setShowPopupDropDownSensor(false);
              }}
              getValueFromLefSideMenu={getValueFromLefSideMenu}
              openLayerTypeMap={openLayerTypeMap}
              handleButtonClickMinMenuRain={handleButtonClickMinMenuRain}
              handleButtonClickMinMenuRiver={handleButtonClickMinMenuRiver}
              handleButtonClickMinMenuAir={handleButtonClickMinMenuAir}
              minMenuAir={minMenuAirLeft}
              minMenuRiver={minMenuRiverLeft}
              minMenuRain={minMenuRainLeft}
              addLayerPopupFromMini={AddLayerDropDown}
              getUser={getUser ?? ""}
            />
          </div>
        )}
        {(getValueFromLefSideMenu === "Reported Incidents" ||
          getValueFromLefSideMenu === "Early Warnings" ||
          getValueFromLefSideMenu === "Satellite Imagery") && (
            <div
              style={{
                position: "absolute",
                top: "30%",
                left: "13vw",
                opacity: showPopupDropDown ? 1 : 0, // Fades in and out
                pointerEvents: showPopupDropDown ? "auto" : "none", // Prevents interaction when hidden
                transition: "opacity 0.3s ease",
              }}
            >
              {/* {showPopupDropDown && ( */}
              <MainLayerPopup
                popupLayerType={getValueFromLefSideMenu}
                passStartDurationForm={setTimeRangePopupFrom}
                passFromDurationTo={setTimeRangePopupTo}
                endTime={getDateSlotValueFromTimelines}
                playTimer={playTimerMain}
                showTimeRangeNotification={() => {
                  setShowTimeRangeNotification(true);
                }}
                closePopupDropDown={() => {
                  setShowPopupDropDown(false);
                }}
                passClickedHzIncidentMapValue={handleClickedHzIncident}
                addLayerPopup={AddLayerDropDown}
                layerValueFromMainMenu={setValueFromLefSideMenu}
                passClickedEWSValue={handleClickedEWS}
                timeLineHour={getTimeSlotValueFromTimelines}
                timeLineDate={getDateSlotValueFromTimelines}
                openLayerTypeMap={openLayerTypeMap}
                sensorType={setSensorType}
                openModular={setOpenModular}
                renderEWS={setrenderEWS}
                renderHz={setrenderHz}
              />
              {/* )} */}
            </div>
          )}
        <div style={{ position: "absolute" }}>
          {showAddLayer && <AddLayerComp close={AddLayerDropDown} />}
        </div>
        {open && (
          <div>
            <LocationSideBar
              updateParentState={updateParentState}
              // location={hdms}
              locationCoordinates={locationCoordinates}
            />
          </div>
        )}

        <div
          style={{ position: "absolute", left: "30px", bottom: "50px" }}
          onMouseEnter={handleMouseEnterModelType}
          onMouseLeave={handleMouseLeaveModelType}
        >
          {getValueFromLefSideMenu === "Flood" && (
            <FloodModel setSelectedModel={setSelectedModel} />
          )}
          {(TimeLayer === "windnot" ||
            TimeLayer === "temperaturenot" ||
            TimeLayer === "rainnot" ||
            TimeLayer === "airPressurenot" ||
            TimeLayer === "pressurenot" ||
            TimeLayer === "tidesnot" ||
            TimeLayer === "rainProbabilitynot" ||
            atmosphericRivers === "Atmospheric Rivers" ||
            cyclones === "Cyclones" ||
            tonardo === "Tonardo" ||
            droughts === "Droughts" ||
            jetStreams === "JetStreams" ||
            stormSurges === "StormSurges" ||
            dustStorms === "DustStorms") && (
              <ForecastModel setSelectedModel={setSelectedModel} />
            )}
        </div>
        <div className={`forecast-btn-title ${showModel ? "show" : ""}`}>
          Forecast Model
        </div>
        <div
          style={{ position: "absolute", left: "30px", bottom: "15px" }}
          onMouseEnter={handleMouseMessureTypes}
          onMouseLeave={handleMouseLeaveMessureTypes}
        >
          <MessureUnits messureUnitLayer={TimeLayer} />
        </div>
        <div className={`messure-btn-title ${showMessure ? "show" : ""}`}>
          Messure Unit
        </div>
        <div
          style={{
            bottom: "0.5vh",
            marginLeft: "40%",
            marginRight: "50%",
            position: "fixed",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <QuickMenu
            data={data}
            activeSlide={4}
            voiceRecognitionValue={setVoiceRecognitionValue}
            openConsole={setVoiceRecognitionConsole}
            setVoiceCommand={setVoiceCommand}

          />
        </div>
        <div style={{ position: "absolute", right: "1vw", bottom: "18vh" }}>
          {openVoiceRecognitionConsole && (
            // <VoiceRecognitionConsole
            //   onCloseConsole={() => setVoiceRecognitionConsole(false)}
            //   voiceValue={getVoiceRecognitionValue}
            // />
            <VoiceTerminal setTerminalState={setVoiceRecognitionConsole} voiceCommand={voiceCommand} easyAccessCommand={getVoiceRecognitionValue} setEasyAccessCommand={setVoiceRecognitionValue} />
          )}
        </div>
        <div
          style={{
            position: "absolute",
            top: "8vh",
            left: "35vw",
          }}
        >
          {isSummaryMoreDetailsOpen && layout === "hawk eye" && (
            <SummeryFull
              onClose={handleSummeryClose}
              earlyWarningsFromChild={earlyWarningsFromChild}
              hzDatafromSummery={hzDatafromSummery}
            />
          )}
        </div>
        <div
          style={{
            position: "absolute",
            top: "8vh",
            left: "35vw",
          }}
        >
          {isEwsServerityOpen && layout === "hawk eye" && (
            <DetailsEWSeverity
              onClose={handleEWSSeverityClose}
              earlyWarningsFromChild={filterEws}
            />
          )}
        </div>
        <div
          style={{
            position: "absolute",
            top: "8vh",
            left: "35vw",
          }}
        >
          {detailsByTypeOpen && layout === "hawk eye" && (
            <DetailsByType
              onClose={handleDetailsByTypeClose}
              earlyWarningsFromChild={filterEwsByType}
              filterHzByType={filterHzByType}
            />
          )}
        </div>
      </div>
    </div>
  );
}
